export default "__VITE_PUBLIC_ASSET__56a57d34__"